import { Notify } from 'vant'
export const errMsg = (msg) => {
  Notify({ type: 'danger', message: msg, background: '#ee0a24' })
}
export const successMsg = (msg) => {
  Notify({ type: 'success', message: msg, background: '#07c160' })
}